<script>
import { axiosGetPost } from '@router/axiosGetPost'
import { downloadOperationsFile } from '@components/downloadOperationsFile'
import { downloadRequest } from '@components/downloadRequest'
import WaitingStatus from '@/src/components/WaitingStatus'
import 'vue-select/dist/vue-select.css'
export default {
  name: 'compareDuplicates',
  components: {
    WaitingStatus,
  },
  props: {
    requestId: [Number, String],
    type: String,
  },

  data() {
    return {
      request_id: this.requestId,
      loadingDataDp: false,
      loadingTask: false,
      url: {
        compareDuplicates: `/requests/compareDuplicates/${this.requestId}`,
        duplicateContract: 'contracts/duplicate',
        tryAgain: `/requests/compareDuplicatesTryAgain/${this.type}/${this.requestId}`,
      },
      emit: null,
      compareFilesDp: {
        id: null,
        detailId: null,
        detailBool: false,
        detailText: null,
        non_sheets: [],
        request_base: null,
        locket_op: true,
        cmpfiles: [
          {
            sheets: null,
            mean: 0,
            detail: null,
            non_sheets: [],
            request_id: null,
            company_user: null,
            status: null,
          },
        ],
      },
    }
  },
  created() {
    this.request_id = this.requestId
    this.emit = 'closeModalRequest'
    this.fecthdata()
  },
  methods: {
    fecthdata() {
      this.loadingDataDp = true
      axiosGetPost('post', this.url.compareDuplicates, {
        re_search: false,
        module: this.type,
      }).then((response) => {
        if (response.success === true) {
          this.cleanShowDetail()
          this.compareFilesDp.id = this.request_id
          this.compareFilesDp.cmpfiles = response.data
          this.compareFilesDp.request_base = response.request_base
          this.compareFilesDp.locket_op = response.locket_op
        } else {
          this.cleanShowDetail()
          this.$toastr.e(
            `Error. Status code: ${response.success}  Error: ${response.error}`
          )
        }
        this.loadingDataDp = false
        return response
      })
    },
    showDetail(data) {
      this.cleanShowDetail()
      this.compareFilesDp.detailId = data.request_id
      this.compareFilesDp.non_sheets = data.non_sheets
      this.compareFilesDp.detail = data.detail
      this.compareFilesDp.detailBool = true
    },
    cleanShowDetail() {
      this.compareFilesDp.request_base = null
      this.compareFilesDp.detailBool = false
      this.compareFilesDp.detailText = null
      this.compareFilesDp.detailId = null
      this.compareFilesDp.non_sheets = []
    },
    duplicateQuestion(fromD, toD) {
      this.$swal({
        title: `Do you want to duplicate the request ${fromD} to ${toD}?`,
        text: 'The process will duplicate the contract information',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.loadingDataDp = true
          // call the method that loads the data and enable this.tableLoaded = true once finished
          axiosGetPost(
            'post',
            `${this.url.duplicateContract}/${fromD}/${toD}`,
            {
              module: this.type,
            }
          ).then((response) => {
            if (response.success === true) {
              this.loadingDataDp = false
              this.$swal('OK')
              this.$emit(this.emit, toD)
              this.$emit(
                'ev_update_fields',
                toD,
                response.status,
                response.usernameLoad,
                response.locked_options
              )
              return response
            } else {
              this.loadingDataDp = false
              this.$toastr.e('Base is not Done. Not duplicate')
            }
          })
        } else {
          this.$swal('Canceled')
        }
      })
    },
    startCompareDuplicatesTryAgain() {
      this.loadingTask = true
      axiosGetPost('get', this.url.tryAgain, {}).then((response) => {
        if (response.success === true) {
          this.cleanShowDetail()
        } else {
          this.cleanShowDetail()
          this.$toastr.e(
            `Error. Status code: ${response.success}  Error: ${response.error}`
          )
        }
        this.loadingDataDp = false
        return response
      })
      this.$toastr.s('Searching for possible duplicates!')
    },
    endCompareDuplicatesTryAgain() {
      this.loadingTask = false
      this.loadingDataDp = true
      axiosGetPost('post', this.url.compareDuplicates, {
        re_search: false,
        module: this.type,
      }).then((response) => {
        if (response.success === true) {
          this.cleanShowDetail()
          this.compareFilesDp.cmpfiles = response.data
        } else {
          this.cleanShowDetail()
          this.$toastr.e(
            `Error. Status code: ${response.success}  Error: ${response.error}`
          )
        }
        this.loadingDataDp = false
        return response
      })
    },
    loadDpLog(id) {
      this.$root.$emit('loadDuplicateLog', id)
    },
    downloadOperationsF(id) {
      downloadOperationsFile(id, this.type)
    },
    downloadRequestF(id) {
      downloadRequest(id, this.type)
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingDataDp"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="col-md-12 mt-0 mb-1">
        <div class="form-group row">
          <div class="col-md-4">
            <h4 class="header-title mt-0 mb-1">
              <i class="uil uil-files-landscapes"></i> Request ID:
              {{ compareFilesDp.id }}
            </h4>
          </div>
          <div class="col-md-4">
            <h4
              v-if="compareFilesDp.request_base !== null"
              class="header-title mt-0 mb-1"
            >
              <i class="uil uil-shield-check"></i> Request Base:
              <a
                href="#"
                title="which contracts were duplicated from this"
                @click="loadDpLog(compareFilesDp.request_base)"
                >{{ compareFilesDp.request_base }}</a
              >
            </h4>
            <h4 v-else class="header-title mt-0 mb-1">
              <i class="uil uil-shield-check"></i> Original
            </h4>
          </div>
          <div class="col-md-4">
            <b-button
              class="float-right btn-sm col-9"
              variant="outline-primary"
              @click="startCompareDuplicatesTryAgain"
            >
              Try Again &nbsp; <i class="uil uil-redo"></i>
            </b-button>
          </div>
        </div>
        <!-- <br /> -->
        <WaitingStatus
          v-if="loadingTask === true"
          :request-id="compareFilesDp.id"
          :reload-time="10"
          :url="`/requests/statusTaskFilterAndCompare/${type}/`"
          @postevent="endCompareDuplicatesTryAgain"
          has-post-event
        />
        <div v-else-if="compareFilesDp.cmpfiles && loadingTask === false">
          <div class="table-responsive table-responsive-list-menu">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th scope="col">Request ID</th>
                  <th scope="col">Company User</th>
                  <th scope="col">Validation</th>
                  <th scope="col">Mean</th>
                  <th scope="col">Sheets</th>
                  <th scope="col">Status</th>
                  <th scope="col">Options</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, r) in compareFilesDp.cmpfiles" :key="r">
                  <th scope="row">{{ row.request_id }}</th>
                  <td>{{ row.company_user }}</td>
                  <td>{{ row.validation }}</td>
                  <td>{{ row.mean }}%</td>
                  <td>{{ row.sheets }}</td>
                  <td
                    :class="
                      row.status.toLowerCase() === 'done'
                        ? 'text-color-green'
                        : 'text-color-red'
                    "
                    >{{ row.status }}</td
                  >
                  <td>
                    <div class="form-group row d-flex">
                      <div class="col-md-1 mt-3">
                        <div
                          :class="[
                            !row.is_importation ? 'circle-red' : 'circle-green',
                          ]"
                        ></div>
                      </div>
                      <div class="col-md-10">
                        <b-dropdown
                          :ref="`actions_dropdown_${row.request_id}`"
                          variant="success"
                          dropleft
                          class="ml-1 btn-sm"
                        >
                          <template slot="button-content">
                            <i
                              class="uil uil-angle-double-left"
                              style="color: #278c27"
                            ></i>
                            <i>Options</i>
                          </template>

                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="showDetail(row)"
                          >
                            <span style="color: rgb(1 38 113)">
                              <i class="uil uil-file-search-alt"></i>
                              &nbsp; &nbsp; Detail
                            </span>
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="row.is_importation"
                            href="#"
                            style="color: ##0a399a"
                            @click="downloadOperationsF(row.request_id)"
                          >
                            <span style="color: green">
                              <i class="uil uil-cloud-upload"></i>
                              &nbsp; &nbsp; Operations File
                            </span>
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-else
                            href="#"
                            style="color: ##0a399a"
                          >
                            <span style="color: rgb(187, 58, 3)">
                              <i class="uil uil-copy"></i>
                              &nbsp; &nbsp; It's duplicate
                            </span>
                          </b-dropdown-item>

                          <b-dropdown-item
                            href="#"
                            style="color: ##0a399a"
                            @click="downloadRequestF(row.request_id)"
                          >
                            <span style="color: rgb(1 38 113)">
                              <i class="uil uil-cloud-download"></i>
                              &nbsp; &nbsp; Request File
                            </span>
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="
                              compareFilesDp.locket_op === false &&
                                row.status.toLowerCase() === 'done'
                            "
                            href="#"
                            style="color: ##0a399a"
                            @click="
                              duplicateQuestion(
                                row.request_id,
                                compareFilesDp.id
                              )
                            "
                          >
                            <span style="color: rgb(1 38 113)">
                              <i class="uil uil-file-search-alt"></i>
                              &nbsp; &nbsp; Duplicate
                            </span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else>
          <div
            class="row align-items-center justify-content-center"
            style="height: 180px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">No matches found!</h6>
            </div>
          </div>
        </div>
      </div>
      <div v-if="compareFilesDp.detailBool">
        <div class="col-md-12 mt-0 mb-1">
          <h4 class="header-title mt-0 mb-1"
            >Detail:
            {{
              compareFilesDp.id + ' / Request: ' + compareFilesDp.detailId
            }}</h4
          >

          <span
            v-for="(rw_leave, values_leave) in compareFilesDp.detail"
            :key="values_leave"
          >
            <span v-if="rw_leave.length >= 1">
              Leaves not found. Request {{ values_leave }}:
              {{ rw_leave.length >= 1 ? rw_leave : 'N/A' }}
              <br />
            </span>
          </span>

          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th scope="col">Sheet</th>
                  <th scope="col">Coordinates</th>
                  <th scope="col">Data Hidden</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, r) in compareFilesDp.non_sheets" :key="r">
                  <th scope="row">{{ r }}</th>
                  <td v-if="row['differences'].length >= 1">
                    {{ row['differences'] }}</td
                  >
                  <td v-else> N/A </td>
                  <td>
                    <ul>
                      <li v-for="(style, s) in row['styles']" :key="s">
                        {{ s }}:
                        <span v-if="style.length == 1">
                          {{ style[0] }}
                        </span>
                        <span v-else-if="style.length > 1">
                          {{ style }}
                        </span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.circle-green {
  width: 10px !important;
  height: 10px !important;
  background-color: green;
  border-radius: 50%;
}

.circle-red {
  width: 10px !important;
  height: 10px !important;
  background-color: rgb(187, 58, 3);
  border-radius: 50%;
}
.text-color-green {
  color: green; /* Color cuando la condición es true */
}
.text-color-red {
  color: rgb(187, 58, 3); /* Color cuando la condición es false */
}
</style>
